export default "__VITE_ASSET__cfd36010__"